import React, {useEffect, useRef, useState } from 'react'
import IconCalendrier from '../assets/icons/iconCalendrier.svg'

const FiltreDate = ({
    setStartDateProps, setEndDateProps
}) => {

     const formatDate = (date) => {
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, '0');
      const d = String(date.getDate()).padStart(2, '0');
      return `${y}-${m}-${d}`;
      }

      const newDate= formatDate(new Date())
      const [startDate, setStartDate] = useState('');
      const [endDate, setEndDate] = useState('')


    const startDateRef= useRef(null)
    const endDateRef= useRef(null)
  return (
    <div className="flex items-center p-2 rounded-xl shadow-sm h-[48px] border border-slate-200">
          <input
          ref={startDateRef}
            type="date"
            value={startDate}
            max={endDate? endDate : newDate}
            onChange={(e) =>{
              setStartDate(e.target.value)
              setStartDateProps(e.target.value)
              if(!endDate){
                setEndDate(newDate)
              setEndDateProps(newDate)}

            }}
            className="text-[10px] font-bold text-[#5d55e8] outline-none "
          />
           <img className="w-[10px] h-auto cursor-pointer" 
           src={IconCalendrier} 
           alt="IconCalendrier" 
           onClick={() => startDateRef.current?.showPicker?.()}
           width={20} height={22}
           />

          <span className="text-slate-300 self-center">→</span>
          <input
          ref={endDateRef}
            type="date"
            value={endDate}
            // min={startDate}
            // max={new Date().toISOString().split("T")[0]}
            max={formatDate(new Date())}
            onChange={(e) =>{
              const newEnd= e.target.value
              if(newEnd > startDate) {
                console.log('okok')
              setEndDate(newEnd)
              setEndDateProps(newEnd)
              

            }}}
            className="text-[10px] font-bold text-[#5d55e8] outline-none "
          />
           <img className="w-[10px] h-auto cursor-pointer"  
           src={IconCalendrier} 
           alt="IconCalendrier" 
           onClick={() => endDateRef.current?.showPicker?.()} 
           width={20} height={22}
           />
          
        </div>
  )
}

export default FiltreDate
